<template>
	<ConfirmationDialog
		className="link-dialog"
		:actions="actions"
	>
		<template v-slot:header>
			<div>
				{{ $t( "common.LinkDialog_urlFieldLabel" )}}
			</div>
		</template>

		<template v-slot:description>
			<div>
				<TeamingTextbox
					name="link"
					:value="url"
					:focus="true"
					:isValid="isValidUrl"
					@input="onInput"
				/>
			</div>
			<div
				v-if="shouldShowValidationError"
				class="link-dialog__error"
			>
				{{ $t( "common.LinkDialog_invalidLinkMessage" ) }}
			</div>
		</template>
	</ConfirmationDialog>
</template>

<script>
import * as KeyCode from "keycode-js";

import {
	ConfirmationDialog,
	TeamingTextbox
} from "@teaming/common-ui";

export default {
	name: "LinkDialog",
	components: {
		ConfirmationDialog,
		TeamingTextbox,
	},
	emits: [ "cancel", "submit", ],
	data() {
		return {
			url: "",
			saveAttempted: false,
		};
	},
	props: {
		documentName: {
			type: String,
			required: true,
		},
	},
	computed: {
		actions() {
			return [
				{
					id: "save",
					type: "PRIMARY",
					label: this.$t( "common.LinkDialog_saveBtnLabel" ),
					isDestructive: false,
					onButtonPress: async () => {
						this.saveAttempted = true;
						await this.$nextTick();
						if ( !this.shouldShowValidationError ) {
							this.$emit( "submit", this.url );
						}
					},
				},
				{
					id: "cancel",
					type: "SECONDARY",
					label: this.$t( "common.LinkDialog_cancelBtnLabel" ),
					isDestructive: false,
					onButtonPress: () => {
						this.$emit( "cancel" );
					},
				},
			];
		},
		isValidUrl() {
			if ( !this.saveAttempted ) {
				return true;
			}
			try {
				const parsedUrl = new URL( this.url );
				return parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
			} catch {
				return false;
			}
		},
		shouldShowValidationError() {
			return this.url && !this.isValidUrl && this.saveAttempted;
		},
	},
	watch: {
		// url( newVal, oldVal ) {
		// 	if ( newVal && newVal !== oldVal ) {
		// 		this.saveAttempted = true;
		// 	}
		// },
	},
	methods: {
		getPreviousUrl() {
			const registry = this.$documentRegistry();
			if ( !registry.isConnected( this.documentName ) ) {
				return;
			}
			const manager = this.$documentRegistry()
				.manage( this.documentName );
			const activeEditor = manager.getActiveEditor();
			if ( activeEditor ) {
				this.url = activeEditor.getAttributes( "link" ).href;
			}
		},
		onInput( e ) {
			this.url = e.target.value;
		},
		onKeyboardInput( e ) {
			if ( e.code === KeyCode.CODE_ESCAPE ) {
				return this.$emit( "cancel" );
			}
			if ( [ KeyCode.CODE_ENTER, KeyCode.CODE_RETURN, ].includes( e.code ) ) {
				this.$emit( "submit", this.url );
			}
		},
	},
	mounted() {
		window.addEventListener( "keyup", this.onKeyboardInput );
		this.getPreviousUrl();
	},
	updated() {
		this.getPreviousUrl();
	},
	beforeUnmount() {
		window.removeEventListener( "keyup", this.onKeyboardInput );
	},
};
</script>

<style lang="scss">
.link-dialog {
	.confirmation-dialog__content {
		width: 21.5rem;
	}
}

.link-dialog__error {
	padding-top: .5rem;
	@include font-and-line-for(-1);
}
</style>
